document.addEventListener('click', function (event) {
	if (event.target.matches('.oj-pdp-accordion__title')) {
		const accordionTitle = document.querySelectorAll('.oj-pdp-accordion__title');
		const activeAccordionContent = document.getElementById('oj-pdp-accordion__content-' + event.target.dataset.index)
		const accordionContent = document.querySelectorAll('.oj-pdp-accordion__content')
		accordionContent.forEach((e) => {
			e.classList.remove('active')
		})
		accordionTitle.forEach((e) => {
			e.classList.remove('active')
		})
		event.target.classList.add('active')
		activeAccordionContent.classList.add('active')
	}
})